import './Card.css';

import React from 'react'
import { Link } from 'react-router-dom';

function Card({ videos }) {
    return (
        <div className="cards-row">
            {videos.map((video) => {
                return (
                    <div className="card-tile" key={video.id}>
                        <Link to={"/video/" + video.id} id={video.id} key={video.id}>
                            <img src={video.thumbnail_src} alt="" />
                            <div className="content">
                                <p className="title">{video.title}</p>
                                <p className="host">{video.host_name}</p>
                            </div>
                        </Link>
                    </div>
                );
            })}
        </div>
    )
}

export default Card
